import { render, staticRenderFns } from "./creerPointDeVente.vue?vue&type=template&id=0f4b4a42"
import script from "./creerPointDeVente.vue?vue&type=script&lang=js"
export * from "./creerPointDeVente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports